import { render, staticRenderFns } from "./MedSurvey.vue?vue&type=template&id=f435a83a&scoped=true&"
import script from "./MedSurvey.vue?vue&type=script&lang=js&"
export * from "./MedSurvey.vue?vue&type=script&lang=js&"
import style0 from "./MedSurvey.vue?vue&type=style&index=0&id=f435a83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f435a83a",
  null
  
)

export default component.exports